/**
 * Metanow quantity selector popup
 * --------------------------------
 * Intercepts clicks on [data-metanow-qty-popup] triggers, opens the popup,
 * handles tier selection + custom quantity, and posts to /cart/add.js.
 *
 * Shopify AJAX API: https://shopify.dev/docs/api/ajax/reference/cart
 */
(function () {
  'use strict';

  var CURRENCY_FORMAT = window.Shopify && window.Shopify.money_format
    ? window.Shopify.money_format
    : '{{amount}}';

  var state = {
    open: false,
    trigger: null,
    variantId: null,
    price: 0,
    compareAt: 0,
    currency: '£',
    title: '',
    productUrl: '/',
    tiers: [1, 2, 4, 6],
    saveLabel: '',
    selectedQty: 1,
    customMode: false,
    customQty: 1,
    lastFocused: null
  };

  var el = {};

  function $(sel, root) { return (root || document).querySelector(sel); }
  function $$(sel, root) { return Array.prototype.slice.call((root || document).querySelectorAll(sel)); }

  function formatMoney(amountMinor) {
    // amountMinor is in minor units (pence). Always render with 2 decimals.
    var value = (amountMinor / 100).toFixed(2);
    return state.currency + value;
  }

  function parseAttrNumber(value, fallback) {
    if (value === null || value === undefined || value === '') return fallback;
    // Accept "59.40", "59,40", "5,940.00"
    var normalized = String(value).replace(/,/g, function (match, offset, str) {
      // If comma is used as decimal separator (last comma, 2 digits after), convert to dot
      var afterComma = str.substring(offset + 1);
      return /^\d{1,2}$/.test(afterComma) ? '.' : '';
    });
    var n = parseFloat(normalized);
    return isNaN(n) ? fallback : n;
  }

  function toMinor(value) {
    // Convert major-unit number to integer minor units
    return Math.round(value * 100);
  }

  function init() {
    el.popup = $('#metanow-qty-popup');
    if (!el.popup) return;

    el.dialog = $('.metanow-qty-popup__dialog', el.popup);
    el.tiers = $('[data-metanow-tiers]', el.popup);
    el.stepValue = $('[data-metanow-step-value]', el.popup);
    el.total = $('[data-metanow-total]', el.popup);
    el.save = $('[data-metanow-save]', el.popup);
    el.custom = $('[data-metanow-custom]', el.popup);
    el.btnAdd = $('[data-metanow-action="add"]', el.popup);
    el.btnBuy = $('[data-metanow-action="buy"]', el.popup);

    // Delegate clicks on any Buy Now trigger anywhere on the page
    document.addEventListener('click', onDocumentClick, true);

    // Close handlers
    $$('[data-metanow-close]', el.popup).forEach(function (node) {
      node.addEventListener('click', close);
    });

    // Stepper
    $$('[data-metanow-step]', el.popup).forEach(function (btn) {
      btn.addEventListener('click', function () {
        var delta = parseInt(btn.getAttribute('data-metanow-step'), 10) || 0;
        setCustomQty(state.customQty + delta);
      });
    });

    // Action buttons
    el.btnAdd.addEventListener('click', function () { submit('add'); });
    el.btnBuy.addEventListener('click', function () { submit('buy'); });

    // ESC key
    document.addEventListener('keydown', function (e) {
      if (state.open && e.key === 'Escape') close();
    });
  }

  function onDocumentClick(e) {
    var trigger = e.target.closest ? e.target.closest('[data-metanow-qty-popup]') : null;
    if (!trigger) return;
    e.preventDefault();
    e.stopPropagation();
    open(trigger);
  }

  function open(trigger) {
    state.trigger = trigger;
    state.variantId = trigger.getAttribute('data-variant-id');
    state.price = parseAttrNumber(trigger.getAttribute('data-price'), 0);
    state.compareAt = parseAttrNumber(trigger.getAttribute('data-compare-at'), 0);
    state.currency = trigger.getAttribute('data-currency') || state.currency;
    state.title = trigger.getAttribute('data-title') || '';
    state.productUrl = trigger.getAttribute('data-product-url') || '/';
    state.saveLabel = trigger.getAttribute('data-save-label') || '';

    var tierAttr = trigger.getAttribute('data-tiers');
    if (tierAttr) {
      var parsed = tierAttr.split(',').map(function (n) { return parseInt(n.trim(), 10); }).filter(function (n) { return n > 0; });
      if (parsed.length) state.tiers = parsed;
    } else {
      state.tiers = [1, 2, 4, 6];
    }

    state.selectedQty = state.tiers[0];
    state.customMode = false;
    state.customQty = 1;

    renderTiers();
    updateTotal();
    el.stepValue.textContent = String(state.customQty);

    state.lastFocused = document.activeElement;
    el.popup.setAttribute('aria-hidden', 'false');
    document.body.classList.add('metanow-qty-popup-open');
    state.open = true;

    // Focus first tier for keyboard users
    setTimeout(function () {
      var firstTier = $('.metanow-qty-popup__tier', el.tiers);
      if (firstTier) firstTier.focus();
    }, 50);
  }

  function close() {
    el.popup.setAttribute('aria-hidden', 'true');
    document.body.classList.remove('metanow-qty-popup-open');
    state.open = false;
    if (state.lastFocused && state.lastFocused.focus) state.lastFocused.focus();
  }

  function renderTiers() {
    el.tiers.innerHTML = '';
    state.tiers.forEach(function (qty) {
      var btn = document.createElement('button');
      btn.type = 'button';
      btn.className = 'metanow-qty-popup__tier';
      btn.setAttribute('data-qty', String(qty));
      btn.setAttribute('aria-pressed', (!state.customMode && qty === state.selectedQty) ? 'true' : 'false');

      var now = state.price * qty;
      var was = state.compareAt ? state.compareAt * qty : 0;

      btn.innerHTML = [
        '<span class="metanow-qty-popup__tier-title">', qty, ' ', (qty === 1 ? 'Treatment' : 'Treatments'), '</span>',
        '<span class="metanow-qty-popup__tier-price">',
          '<span class="metanow-qty-popup__tier-price-now">', formatMoney(toMinor(now)), '</span>',
          (was && was > now ? '<span class="metanow-qty-popup__tier-price-was">' + formatMoney(toMinor(was)) + '</span>' : ''),
        '</span>',
        '<span class="metanow-qty-popup__tier-per">', formatMoney(toMinor(state.price)), ' per treatment</span>'
      ].join('');

      btn.addEventListener('click', function () {
        state.customMode = false;
        state.selectedQty = qty;
        updateTierStates();
        updateTotal();
      });

      el.tiers.appendChild(btn);
    });
  }

  function updateTierStates() {
    $$('.metanow-qty-popup__tier', el.tiers).forEach(function (btn) {
      var qty = parseInt(btn.getAttribute('data-qty'), 10);
      var active = !state.customMode && qty === state.selectedQty;
      btn.setAttribute('aria-pressed', active ? 'true' : 'false');
    });
    el.custom.style.borderColor = state.customMode ? 'var(--metanow-accent)' : '';
    el.custom.style.boxShadow = state.customMode ? 'inset 0 0 0 1px var(--metanow-accent)' : '';
  }

  function setCustomQty(next) {
    if (next < 1) next = 1;
    if (next > 999) next = 999;
    state.customQty = next;
    state.customMode = true;
    state.selectedQty = next;
    el.stepValue.textContent = String(next);
    updateTierStates();
    updateTotal();
  }

  function updateTotal() {
    var qty = state.customMode ? state.customQty : state.selectedQty;
    var total = state.price * qty;
    el.total.textContent = formatMoney(toMinor(total));

    if (state.saveLabel) {
      el.save.textContent = state.saveLabel;
      el.save.hidden = false;
    } else if (state.compareAt && state.compareAt > state.price) {
      var pct = Math.round((1 - state.price / state.compareAt) * 100);
      el.save.textContent = 'Save ' + pct + '%';
      el.save.hidden = false;
    } else {
      el.save.hidden = true;
    }
  }

  function setLoading(which, loading) {
    var btn = which === 'add' ? el.btnAdd : el.btnBuy;
    var spinner = $('.metanow-qty-popup__spinner', btn);
    btn.disabled = loading;
    if (spinner) spinner.hidden = !loading;
    el.btnAdd.disabled = loading;
    el.btnBuy.disabled = loading;
  }

  function submit(action) {
    if (!state.variantId) {
      console.warn('[metanow-qty-popup] Missing variant id on trigger.');
      return;
    }
    var qty = state.customMode ? state.customQty : state.selectedQty;

    setLoading(action, true);

    var formData = new FormData();
    formData.append('id', state.variantId);
    formData.append('quantity', qty);

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Accept': 'application/javascript' },
      body: formData,
      credentials: 'same-origin'
    })
      .then(function (res) {
        if (!res.ok) return res.json().then(function (err) { throw err; });
        return res.json();
      })
      .then(function (data) {
        // Notify theme so cart drawers refresh (Horizon listens to this)
        document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
        document.dispatchEvent(new CustomEvent('cart:updated', { bubbles: true, detail: data }));

        if (action === 'buy') {
          window.location.href = '/checkout';
        } else {
          // Try to open the theme's cart drawer; fall back to redirect.
          var opened = tryOpenCartDrawer();
          setLoading(action, false);
          if (!opened) {
            close();
            window.location.href = '/cart';
          } else {
            close();
          }
        }
      })
      .catch(function (err) {
        setLoading(action, false);
        var msg = (err && err.description) ? err.description : 'Sorry, we could not add that to your cart.';
        alert(msg);
      });
  }

  function tryOpenCartDrawer() {
    // Horizon / Dawn-style cart drawers
    var selectors = [
      'cart-drawer', 'cart-notification',
      '[data-cart-drawer]', '[is="cart-drawer"]',
      '.js-drawer-open-cart'
    ];
    for (var i = 0; i < selectors.length; i++) {
      var node = document.querySelector(selectors[i]);
      if (node) {
        if (typeof node.open === 'function') { node.open(); return true; }
        if (typeof node.show === 'function') { node.show(); return true; }
        if (node.click) { node.click(); return true; }
      }
    }
    // Generic cart toggle button
    var toggle = document.querySelector('[data-cart-drawer-toggle], [aria-controls*="cart"]');
    if (toggle && toggle.click) { toggle.click(); return true; }
    return false;
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
